import { Link } from "react-router-dom";
import { useCalls } from "@/CallsContext";
import { breakdownByCompany, currencySymbol, minutesLabel, money, summarize } from "@/lib/callStats";

export default function CompaniesPage() {
  const { visible, period } = useCalls();
  const symbol = currencySymbol(visible);
  const rows = breakdownByCompany(visible);
  const max = rows[0]?.earnings || 1;
  const stats = summarize(visible);

  return (
    <div className="mpd-page">
      <div className="mpd-page-head">
        <div>
          <p className="mpd-kicker">Companies</p>
          <h1>Where you earned</h1>
          <p className="mpd-sub">
            {rows.length} {rows.length === 1 ? "company" : "companies"} · {money(stats.earnings, symbol)} estimated in {period.label}
          </p>
        </div>
        <Link className="mpd-primary" to="/pay-rates">Pay Rates</Link>
      </div>

      <article className="mpd-card">
        {rows.length === 0 ? (
          <p className="mp-empty">No company data in this period.</p>
        ) : (
          <ul className="mpd-companies mpd-companies-full">
            {rows.map((row) => (
              <li key={row.name}>
                <div className="mpd-companies-row">
                  <strong>{row.name}</strong>
                  <span>{money(row.earnings, symbol)}</span>
                </div>
                <div className="mpd-bar">
                  <span style={{ width: `${Math.round((row.earnings / max) * 100)}%` }} />
                </div>
                <p className="mpd-muted">
                  {row.calls} {row.calls === 1 ? "call" : "calls"} · {minutesLabel(row.minutes)} min · avg {money(row.calls ? row.earnings / row.calls : 0, symbol)} / call · estimated
                </p>
              </li>
            ))}
          </ul>
        )}
      </article>
    </div>
  );
}
